import { LinearProgress } from '@mui/material';

export const Progress = (): JSX.Element => <LinearProgress color="primary" />;

export default Progress;
